module.exports = __webpack_public_path__ + "img/image00005.8cbc16ea.jpeg";